import { connect } from 'react-redux';

import Component from '../../components/js/modules/PageView';
import { IPageDataState } from '../../store/pageData';
import { ITopicsDetailState } from '../../../../common/store/pickup/topicsDetail';
import { IRequestState } from '../../../../common/store/common/request';
import { makeSsJoinParamByArticlePage } from '../../../../common/userActionLogger/SsJoinParamMaker';

interface IStates {
  request?: IRequestState;
  pageData: IPageDataState;
  topicsDetail?: ITopicsDetailState;
}

const mapStateToProps = (state: IStates) => {
  return {
    requestId: state.request?.requestId,
    contentId: state.pageData.pageParam.shcid,
    topicsId: state.topicsDetail?.id,
    mtestId: state.pageData.pageParam.mtestid,
    ssJoinIdParam: makeSsJoinParamByArticlePage(state.pageData.pageParam.conttype, state.pageData.pageParam.mid)
  };
};

export default connect(mapStateToProps)(Component);
